<template>
  <div>
    <a @click="show = true" id="button" class="button is-link">Powered By</a>
    <transition name="fade" mode="in-out">
      <div v-show="show">
        <div class="mask">
          <div class="section">
            <div class="box container has-text-weight-medium">
              This site was built with:
              <ul>
                <li>
                  <a class="is-link" href="https://vuejs.org/" target="_blank"
                    >VueJS</a
                  >
                </li>
                <li>
                  <a class="is-link" href="https://bulma.io" target="_blank"
                    >BulmaCSS</a
                  >
                </li>
                <li>
                  <a
                    class="is-link"
                    href="https://firebase.google.com/"
                    target="_blank"
                    >Google Sheets/Firebase</a
                  >
                </li>
                <li>
                  <a class="is-link" href="https://netlify.com/" target="_blank"
                    >Netlify</a
                  >
                </li>
              </ul>
              <button @click="show = !show" class="button is-link">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Popup",
  data: function() {
    return {
      show: false
    };
  }
};
</script>

<style lang="scss" scoped>
.button {
  display: inline-block;
  margin-top: 1rem;
  margin-bottom: 0.25rem;
}
#button {
  margin: 0rem;
  padding: 0.5rem;
}
.mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: table;
}

.section {
  display: table-cell;
  vertical-align: middle;
}
.is-link {
  margin: 1rem;
}

.box {
  width: 15rem;
  align-items: center;
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
